
import { useInfiniteQuery } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useGetPrivateAnalysesQuery = ({ limit, order, owner }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useInfiniteQuery({
    queryKey: ['privateAnalyses', { limit, order, owner }],
    queryFn: ({ pageParam: cursor = 0 }) => api.list({ limit, order, cursor, owner }),
    getNextPageParam: (lastPage) => {
      if (!lastPage.meta?.cursor) return
      return lastPage.meta.cursor
    },
    refetchOnWindowFocus: false,
    ...options,
  })
}
